import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=0e17319f&scoped=true&"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&id=0e17319f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e17319f",
  null
  
)

export default component.exports